document.addEventListener('DOMContentLoaded', function () {
	let fiscalCode = document.querySelector('#OrderData_ShippingAddress_FiscalCode');
	if (fiscalCode) {
		fiscalCode.dataset.valRequiredif = 'Campo Codice Fiscale: Obbligatorio.';
		fiscalCode.dataset.valRequiredifDependentproperty = 'ShippingRequired';
		fiscalCode.dataset.valRequiredifExpectedvalue = 'True';
		fiscalCode.dataset.valRequiredifOperator = 'EqualTo';
	}
});

